import * as config from "../config";

export const NetworkReadCall = async (body) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  };
  let response_data = await fetch(config.Api_Url, requestOptions);
  let response_json = response_data.json();
  return response_json;
};
